import type { FlightRebookCheckoutFlightDetailsProps } from "./types";
export const FlightRebookCheckoutFlightDetails = ({
  ...props
}: FlightRebookCheckoutFlightDetailsProps) => {
  // Just a placeholder, override in apps
  return null;
};
